/* @flow */

import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import title from "platopulse/hoc/Title";

import Dashboard from "../components/Dashboard.jsx";

import { fetchDatabaseMetadata } from "platopulse/redux/metadata";
import { setErrorPage } from "platopulse/redux/app";

import { getIsEditing, getIsEditingParameter, getIsDirty, getDashboardComplete, getCardList, getRevisions, getCardData, getSlowCards, getEditingParameter, getParameters, getParameterValues } from "../selectors";
import { getDatabases, getMetadata } from "platopulse/selectors/metadata";
import { getUserIsAdmin } from "platopulse/selectors/user";

import * as dashboardActions from "../dashboard";
import {archiveDashboard} from "platopulse/dashboards/dashboards"
import {parseHashOptions} from "platopulse/lib/browser";

const mapStateToProps = (state, props) => {
  return {
      dashboardId:          props.params.dashboardId,

      isAdmin:              getUserIsAdmin(state, props),
      isEditing:            getIsEditing(state, props),
      isEditingParameter:   getIsEditingParameter(state, props),
      isDirty:              getIsDirty(state, props),
      dashboard:            getDashboardComplete(state, props),
      cards:                getCardList(state, props),
      revisions:            getRevisions(state, props),
      dashcardData:         getCardData(state, props),
      slowCards:            getSlowCards(state, props),
      databases:            getDatabases(state, props),
      editingParameter:     getEditingParameter(state, props),
      parameters:           getParameters(state, props),
      parameterValues:      getParameterValues(state, props),
      metadata:             getMetadata(state)
  }
}

const mapDispatchToProps = {
    ...dashboardActions,
    archiveDashboard,
    fetchDatabaseMetadata,
    setErrorPage,
    onChangeLocation: push
}

type DashboardAppState = {
    addCardOnLoad: number|null
}

@connect(mapStateToProps, mapDispatchToProps)
@title(({ dashboard }) => dashboard && dashboard.name)
export default class DashboardApp extends Component {
    state: DashboardAppState = {
        addCardOnLoad: null
    };

    componentWillMount() {
        let options = parseHashOptions(window.location.hash);
        if (options.add) {
            this.setState({addCardOnLoad: parseInt(options.add)})
        }
    }

    render() {
        return <Dashboard addCardOnLoad={this.state.addCardOnLoad} {...this.props} />;
    }
}



// WEBPACK FOOTER //
// ./dashboard/containers/DashboardApp.jsx